import { render, staticRenderFns } from "./DraggableTable.vue?vue&type=template&id=5a15808b&scoped=true"
import script from "./DraggableTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggableTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DraggableTable.vue?vue&type=style&index=0&id=5a15808b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15808b",
  null
  
)

export default component.exports